export const fr = {
  common: {
    yes: 'Oui',
    no: 'Non',
    saved: 'Enregistré',
    get_started: 'Commencez',
    get_started_today: "Commencez aujourd'hui",
    filter: 'Filtre',
    all: 'Tous',
    apply: 'Appliquer',
    unsavedChanges: 'Vous avez des modifications non enregistrées',
    discard: 'Jeter',
    saveChanges: 'Enregistrer les modifications',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    back: 'Retour',
    welcome_back: 'Bon retour',
  },
}
